import { render, staticRenderFns } from "./SnsUpload.vue?vue&type=template&id=3f180a8b&"
import script from "./SnsUpload.vue?vue&type=script&lang=js&"
export * from "./SnsUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports